// https://joshpitzalis.svbtle.com/crud
// https://medium.com/get-it-working/get-googles-firestore-working-with-react-c78f198d2364

import React, { Component } from 'react';

//import Admin from './Admin';
import PreRegisterForm from './PreRegisterForm';
import './App.css';

class App extends Component {

  render() {


    return( <PreRegisterForm />)


  }
}

export default App;
